import cookies from 'js-cookie';
import moment from 'moment';

import { countDownToDate } from '../../utils/helper';

export default (store) => {
  store.registerModule('banners', {
    namespaced: true,
    state: () => ({
      banner: null,
      hideBanner: cookies.get('hideBanners'),
      closedByUser: false,
      active: null,
    }),
    getters: {
      active(state) {
        return state.active;
      },
      closedByUser(state) {
        return state.active && state.active.type === 2 && state.closedByUser;
      },
      alwaysBanner(state) {
        return state.active && state.active.type === 0;
      },
      promoBanner(state) {
        return state.active && state.active.type === 2;
      },
      freeBanner(state) {
        return state.active && state.active.type === 99;
      },
      triggerBanner(state) {
        return state.active && state.active.type === 1;
      },
      hasPromoBanner(state) {
        return state.active && state.active.type === 2 && !state.hideBanner;
      },
      activeTopBanner(state) {
        return state.active && (state.active.type === 1 || state.active.type === 2 || state.active.type === 3 || state.active.type === 99);
      },
      promoOrTrigger(state) {
        const banner = state.active || {};
        if (banner.type === 1 || banner.type === 2 || banner.type === 3) {
          return banner;
        }

        return {};
      },
      showPromoBannerToUser() {
        const currentPrice = store.getters['subscriptions/active'].priceWoutTaxes;

        if (store.getters['auth/user'].activeSubscriptionPlan === 2) {
          return store.getters['subscriptions/annual'].discountPrice < currentPrice;
        }

        return true;
      },
    },
    mutations: {
      setActive(state, banner) {
        state.active = banner;
      },
      toggle(state, payload) {
        state.hideBanner = payload;
      },
      setClosedByUser(state, payload) {
        state.closedByUser = payload;
      },
      setCountdown(state, countdown) {
        if (state.active) {
          if (countdown) {
            state.active.countdown = countdown;
          }
        }
      },
      setCountdownInterval(state, interval) {
        if (state.active) {
          state.active.interval = interval;
        }
      },
      clearCountdownInterval(state) {
        if (state.active) {
          clearInterval(state.active.interval);
          state.active.interval = null;
        }
      },
    },
    actions: {
      async fetch({ commit, dispatch, rootState: { auth, subscriptions } }) {
        const types = ['always', 'trigger', 'promo', 'collection', 'referral', 'loyalty'];
        const offerTypes = {
          1: 'Special Offer',
          3: 'Limited-Time Offer',
          4: 'Friend Referral Offer',
          5: 'Loyalty Offer',
        };
        const bannerIcons = {
          4: 'icon-heart.png',
          5: 'icon-tick.png',
        };
        const { user } = auth;
        const { banners, discountPlan } = await this.$axios.$get('/banners', { progress: false }).catch((e) => {
          console.log('fetch banners error', e);

          return false;
        });

        // if (store.state.campaign === 'campaign-chat-gpt') {
        //   const campaignBanner = {
        //     activation: '2023-07-13 14:00:00',
        //     active: true,
        //     button: 'Take Course',
        //     coupon: null,
        //     couponPercents: null,
        //     currency: 'USD',
        //     discount: null,
        //     discountPrice: null,
        //     duration: null,
        //     endDate: '2023-07-27 14:00:00',
        //     extId: null,
        //     id: 99,
        //     info: '',
        //     plan: null,
        //     price: null,
        //     type: 99,
        //     strictUrl: true,
        //     urlPath: `${this.$config.siteUrl}/courses/intro-to-chatgpt-and-generative-ai/`,
        //     free: true,
        //     priority: 99,
        //   };

        //   if (moment(new Date()) > moment.utc(campaignBanner.activation) && moment(new Date()) < moment.utc(campaignBanner.endDate)) {
        //     banners.push(campaignBanner);
        //   }
        // }

        if (store.state.campaign === 'free-access-2024' && this.$config.project === 'lms' && ((user && !user.activeSubscription) || !user)) {
          const campaignBanner = {
            activation: '2024-07-19 14:00:00',
            active: true,
            button: 'Start Now',
            coupon: null,
            couponPercents: null,
            currency: 'USD',
            discount: null,
            discountPrice: null,
            duration: null,
            endDate: '2024-07-22 13:59:59',
            extId: null,
            id: 99,
            info: '',
            plan: null,
            price: null,
            type: 99,
            strictUrl: true,
            urlPath: `${this.$config.appUrl}/${this.$config.project === 'site' ? 'signup' : 'courses'}/`,
            classBanner: 'free-days',
            free: true,
            priority: 1,
          };

          if (moment(new Date()) > moment.utc(campaignBanner.activation) && moment(new Date()) < moment.utc(campaignBanner.endDate)) {
            banners.push(campaignBanner);
          }
        }

        if (banners) {
          const banner = [];
          let expired = Boolean;
          await dispatch('subscriptions/fetchPrices', null, { root: true });
          banners.sort((a, b) => a.type - b.type).filter((b) => b.active)
            .forEach((b) => {
              if ([0, 4, 5].includes(b.type) && (user && (!user.activeSubscription || (user.activeSubscription && user.activeSubscriptionPlan !== 2 && user.activeSubscriptionPlan !== 3)))) { // always-on only for free, monthly, quarterly users
                expired = false;
              }

              if (b.type === 1) { // trigger - only for free users
                const activeSubscription = user && user.activeSubscription && typeof user.activeSubscriptionPlan !== 'undefined';

                if (user && !activeSubscription) {
                  const endDate = moment(user.registeredAt).add(+b.activation + +b.duration, 'hours').format('YYYY-MM-DD HH:mm:ss');
                  const activationDate = moment(user.registeredAt).add(+b.activation, 'hours').format('YYYY-MM-DD HH:mm:ss');
                  expired = moment() < moment(activationDate) || moment() > moment(endDate);
                } else if (user && activeSubscription) {
                  expired = true;
                }
              }
              if (b.type === 2) {
                expired = moment(new Date()) > moment.utc(b.endDate);
              }

              if (b.type === 3) {
                if (!b.expiration) {
                  expired = false;
                } else {
                  expired = new Date() > new Date(moment.utc(b.expiration).local()).getTime();
                }

                // eslint-disable-next-line no-param-reassign
                b.endDate = b.expiration;
              }

              if (b.type === 99) {
                expired = false;
              }

              let countDownDate;
              if (b.endDate) {
                countDownDate = new Date(moment.utc(`${b.endDate}`).local());
              }

              if (b.type === 1 && user) {
                countDownDate = new Date(moment(user.registeredAt).add(+b.activation + +b.duration, 'hours'));
              }

              const planId = (b.plan || (!b.plan && b.plan === 0)) ? b.plan : discountPlan;
              const plan = subscriptions.plans.find((p) => p.id === planId) || {};

              banner.push({
                ...b,
                expired,
                click: b.urlPath ? 'url' : 'checkout',
                classBanner: [types[b.type] && types[b.type]],
                planShortTitle: plan.shortTitle,
                planTitle: plan.title,
                typeName: types[b.type],
                offerType: offerTypes[b.type],
                countDownDate,
                interval: null,
                startCountdown: ({ clearCallback } = {}) => {
                  const clear = () => {
                    commit('clearCountdownInterval');
                  };

                  const setCountdown = () => {
                    const countdown = countDownToDate(new Date(), countDownDate);
                    commit('setCountdown', countdown);

                    if (!countdown) {
                      clear();

                      if (clearCallback && typeof clearCallback === 'function') {
                        clearCallback();
                      }
                    }
                  };

                  const interval = setInterval(setCountdown, 1000);

                  commit('setCountdownInterval', interval);

                  return clear;
                },
                countdown: {
                  days: 0,
                  hours: 0,
                  minutes: 0,
                  seconds: 0,
                },
                prices: [1, 2, 3, 4, 5].includes(b.type),
                iconImage: bannerIcons[b.type],
              });
            });

          commit('setActive', banner.filter((b) => !b.expired).sort((a, b) => a.priority - b.priority)[0]);
        }
      },
    },
  });
};
